import { Component } from '@angular/core';

@Component({
  selector: 'tlp-password-sent',
  templateUrl: './password-sent.component.html',
  styleUrls: ['./password-sent.component.css']
})
export class PasswordSentComponent {

}
